var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.77 7.51H10.52V3.63C10.5174 3.462 10.4488 3.30177 10.329 3.1839C10.2093 3.06603 10.048 2.99998 9.88 3H6.64C6.47198 2.99998 6.31069 3.06603 6.19095 3.1839C6.07121 3.30177 6.00262 3.462 6 3.63V7.51H3.75C3.68851 7.51234 3.62899 7.53236 3.57859 7.56766C3.52818 7.60296 3.48903 7.65205 3.46581 7.70903C3.44259 7.76602 3.4363 7.8285 3.44768 7.88897C3.45907 7.94945 3.48765 8.00536 3.53 8.05L8.26 12.77L12.99 8.05C13.0324 8.00536 13.0609 7.94945 13.0723 7.88897C13.0837 7.8285 13.0774 7.76602 13.0542 7.70903C13.031 7.65205 12.9918 7.60296 12.9414 7.56766C12.891 7.53236 12.8315 7.51234 12.77 7.51ZM3 14.28V15.78H13.52V14.28H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8cf9fe36461abd6678b44bf36fa38eeb.svg";
export { ForwardRef as ReactComponent };